<template>
  <div>
    <el-alert
      :title="t('accounts.bankInfoAlert')"
      type="warning"
      :closable="false"
      show-icon
      class="mb-5"
    />
    <el-form-item
      :label="t('bankInfo.bank')"
      prop="bank_name"
    >
      <el-select
        v-model="banksRef.item"
        value-key="code"
        :placeholder="t('errors.pleaseSelect', [t('bankInfo.bank')])"
        filterable
        style="width: 100%"
        @change="handleBank"
      >
        <el-option
          v-for="bank in banksRef.list"
          :key="bank.code"
          :label="`[${bank.code}] ${bank.name}`"
          :value="bank"
        />
      </el-select>
    </el-form-item>

    <el-form-item
      :label="t('bankInfo.branch')"
      prop="bank_branch_name"
    >
      <el-select
        v-model="banksRef.branchItem"
        v-loading="banks.loading"
        :placeholder="t('errors.pleaseSelect', [t('bankInfo.branch')])"
        value-key="subcode"
        :disabled="!banks.branchList.length"
        filterable
        style="width: 100%"
        @change="handleBranch"
      >
        <el-option
          v-for="bank in banksRef.branchList"
          :key="bank.subcode"
          :label="`[${bank.subcode}] ${bank.subname}`"
          :value="bank"
        />
      </el-select>
    </el-form-item>

    <el-form-item
      :label="t('bankInfo.accountName')"
      prop="account_name"
    >
      <el-input
        v-model="formData.account_name"
        :placeholder="t('errors.pleaseInput', [])"
        maxlength="10"
        show-word-limit
      />
    </el-form-item>

    <el-form-item
      :label="t('bankInfo.accountNo')"
      prop="account_no"
    >
      <el-input
        v-model="formData.account_no"
        :placeholder="t('errors.pleaseInput', [])"
        maxlength="50"
      />
    </el-form-item>
  </div>
</template>

<script setup>
import { ref, watch } from "vue"
import { useI18n } from "vue-i18n"
import { useVModel } from "@vueuse/core"

const { t } = useI18n()

const props = defineProps({
  modelValue: Object,
  banks: Object,
})
const emit = defineEmits(["update:modelValue", "change:bank"])

const formData = useVModel(props, "modelValue", emit)
const banksRef = ref()

watch(
  () => props.banks,
  (v) => {
    banksRef.value = v
  },
  { deep: true, immediate: true }
)

const handleBank = (bank) => {
  // console.log("bank: ", bank)
  banksRef.value.branch = {}
  formData.value.bank_code = bank.code
  formData.value.bank_name = bank.name
  formData.value.bank_branch_code = null
  formData.value.bank_branch_name = null

  emit("change:bank", bank)
}
const handleBranch = (bank) => {
  // console.log("bank: ", bank)
  formData.value.bank_branch_code = bank.subcode
  formData.value.bank_branch_name = bank.subname
}
</script>
